module.exports=[
	[
		{	
			name:"污水污泥饲料",
			icon:"el-icon-s-home",
			id:"zhuye",
            submenu1:[
				{
                    icon:"el-icon-menu",
					name : "污水污泥",
					to:"/index",
				},
                {
                    icon:"el-icon-menu",
					name : "饲料",
					to:"/siliao",
				},
			],
		},

		{
			name:"司机审核",
			icon:"el-icon-success",
			id:"shenhe",
			submenu1:[
				{
                    icon:"el-icon-menu",
					name:"污水污泥司机审核",
					to:"/shenhe",
				},
				{
                    icon:"el-icon-menu",
					name:"饲料司机审核",
					to:"/shenhe2",
				},
			],
		},

		{
			name:"行驶记录",
			icon:"el-icon-s-promotion",
			id:"xingshijilu",
			submenu1:[
				{
                    icon:"el-icon-menu",
					name:"行驶记录",
					to:"/xsjladmin",
				}
			],
		},

		// {
		// 	name:"猪粪运载",
		// 	icon:"el-icon-s-data",
		// 	id:"zhufenyunzai",
		// 	submenu1:[
		// 		{
        //             icon:"el-icon-menu",
		// 			name:"猪粪运载",
		// 			to:"/zfyzadmin",
		// 		}
		// 	],
		// },


        {
			name:"死猪",
			icon:"el-icon-s-open",
			id:"sizhu",
			submenu1:[
				{
                    icon:"el-icon-menu",
					name:"死猪",
					to:"/sizhuadmin",
				}
			],
		},

		{
			name:"环保",
			icon:"el-icon-s-cooperation",
			id:"huanbao",
			submenu1:[
				{
                    icon:"el-icon-menu",
					name:"环保",
					to:"/huanbaoadmin",
				}
			],
		},

        {
			name:"油耗",
			icon:"el-icon-s-opportunity",
			id:"youhao",
			submenu1:[
				{
                    icon:"el-icon-menu",
					name:"车辆用油",
					to:"/cladmin",
				},
				{
                    icon:"el-icon-menu",
					name:"油耗核销",
					to:"/yhdb",
				},
                {
                    icon:"el-icon-menu",
                    name:"车用尿素",
                    to:"/clnsadmin",
                },
                {
                    icon:"el-icon-menu",
					name:"生产领用",
					to:"/scadmin",
				},
                {
                    icon:"el-icon-menu",
					name:"其他用油",
					to:"/qtadmin",
				},
                {
                    icon:"el-icon-menu",
					name:"油量库存",
					to:"/kucun",
				},
			],
		},

		{
			name:"投诉反馈",
			icon:"el-icon-warning",
			id:"tousu",
			submenu1:[
				{
                    icon:"el-icon-menu",
					name:"投诉反馈",
					to:"/tousufankui",
				}
			],
		},

		{
			name:"食堂评选",
			icon:"el-icon-s-help",
			id:"shitang",
			submenu1:[
				{
                    icon:"el-icon-menu",
					name:"菜单评选",
					to:"/shitang11",
				},
				{
                    icon:"el-icon-menu",
					name:"菜单留言",
					to:"/shitang12",
				},
				{
                    icon:"el-icon-menu",
					name:"物资评选",
					to:"/shitang13",
				},
				{
                    icon:"el-icon-menu",
					name:"满意度调查",
					to:"/shitangpf",
				},
			],
		},
		{
			name:"股东回馈",
			icon:"el-icon-present",
			id:"gudong",
			submenu1:[
				{
                    icon:"el-icon-menu",
					name:"机构持股",
					to:"/gdhk1",
				},
				{
                    icon:"el-icon-menu",
					name:"个人持股",
					to:"/gdhk2",
				},
			],
		},

        {
			name:"系统维护",
			icon:"el-icon-s-check",
			id:"houtai",
			submenu1:[
                {
                    icon:"el-icon-menu",
					name:"车辆维护",
					to:"/carlist",
				},
				{
                    icon:"el-icon-menu",
					name:"工资维护",
					to:"/wages",
				},
                {
                    icon:"el-icon-menu",
					name:"油卡维护",
					to:"/yklist",
				},
                {
                    icon:"el-icon-menu",
					name:"主卡维护",
					to:"/yklist2",
				},
				{
                    icon:"el-icon-menu",
					name:"客户维护",
					to:"/khadmin",
				},
                {
                    icon:"el-icon-menu",
					name:"管理员维护",
					to:"/useradmin",
				},
                {
                    icon:"el-icon-menu",
					name:"权限维护",
					to:"/power",
				}
			],
		},
	],
]